import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack, Text } from "@mantine/core";

const CGV = () => {
  const { t } = useAppTranslation("pages.policies.cgv");

  const getSection = (title: string, description: string) => {
    return (
      <Stack key={title} align="left">
        <SSHeadline
          props={{
            stack: {
              align: "left",
            },
            title: { fz: 22 },
          }}
        >
          <SSWhiteText>{title}</SSWhiteText>
        </SSHeadline>
        <Text className="text-primary-dark-text">{description}</Text>
      </Stack>
    );
  };

  const sections = t("sections", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  return (
    <Stack className="my-20">
      <SSHeadline
        props={{
          title: { order: 1, fz: 35 },
        }}
      >
        <SSWhiteText>{t("title")}</SSWhiteText>
      </SSHeadline>
      <Stack align="left" className="mt-10">
        {sections.map((section) => getSection(section.title, section.text))}
      </Stack>
    </Stack>
  );
};

export default CGV;
